// BugList.js
import React, { useEffect, useState } from 'react';
import BugCard from './BugCard';
import ENDPOINT from '../../data/ENDPOINT';
import Skeleton from '@mui/material/Skeleton';

const BugList = ({programs}) => {


  return (
    <div  className="container p-0">
      <div className="row">
      {programs?<>
      
        {programs.map((program, index) => (
          <BugCard key={index} program={program} />
        ))}
      </>:
      <>

      <div className='col-lg-3 p-2'>
      <Skeleton variant="rectangular" className=" col-12" height={100} />
      </div>

      <div className='col-lg-3 p-2'>
      <Skeleton variant="rectangular" className=" col-12" height={100} />
      </div>


      <div className='col-lg-3 p-2'>
      <Skeleton variant="rectangular" className=" col-12" height={100} />
      </div>


      <div className='col-lg-3 p-2'>
      <Skeleton variant="rectangular" className=" col-12" height={100} />
      </div>


      <div className='col-lg-3 p-2'>
      <Skeleton variant="rectangular" className=" col-12" height={100} />
      </div>

      <div className='col-lg-3 p-2'>
      <Skeleton variant="rectangular" className=" col-12" height={100} />
      </div>

      
      </>}
      </div>
    </div>
  );
};

export default BugList;
